import {
  FETCH_GARAGES_DATA,
  FETCH_GARAGES_SUCCESS,
  FETCH_GARAGES_FAILURE,
  FETCH_GARAGES_EDIT_DATA,
  FETCH_GARAGES_EDIT_SUCCESS,
  FETCH_GARAGES_EDIT_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
  edit: {
    loading: false,
    data: null,
    error: null,
  },
};

const Garages = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GARAGES_DATA:
      return { ...state, loading: true, error: null };
    case FETCH_GARAGES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_GARAGES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case FETCH_GARAGES_EDIT_DATA:
      return { ...state, edit: { loading: true, data: null, error: null } };
    case FETCH_GARAGES_EDIT_SUCCESS:
      return { ...state, edit: { loading: false, data: action.payload, error: null } };
    case FETCH_GARAGES_EDIT_FAILURE:
      return { ...state, edit: { loading: false, data: null, error: action.payload } };

    default:
      return state;
  }
};

export default Garages;
